// extracted by mini-css-extract-plugin
export default {"moreButton":"MoreOptions_moreButton__Haoo4","popoverBox":"MoreOptions_popoverBox__zkGSY"};